import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import Staff from '../components/Staff';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps({ staff, softwares }) {
  return {
    staff,
    softwares,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Staff);
